// extracted by mini-css-extract-plugin
export default {"Navigation":"Navigation_Navigation__BN-kU","Navigation__button":"Navigation_Navigation__button__WT3V2"};